import React from 'react'
import { Button, Container, Text } from '@mantine/core'
import { FaExclamationTriangle } from 'react-icons/fa';
import { Link } from 'react-router-dom';


const NotFound = () => {
    return (
        <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh', justifyContent: 'center' }}>
            <FaExclamationTriangle style={{ marginBottom: '10px' }} size='60' />
            <Text sx={{ fontSize: '50px' }} weight={700}> 404 </Text>
            <Link to='/'>
                <Button color='orange'>
                    Back to Home
                </Button>
            </Link>
        </Container>
    )
}

export default NotFound
